import { Box, Typography } from '@material-ui/core'

import { useStyles } from './styles'

export default function FeatureDescription() {
  const classes = useStyles()

  return (
    <Box className={classes.headerContainer}>
      <Typography variant='body2' className={classes.titleText}>
        Análise Histórica de talhões
      </Typography>
      <Typography variant='body1' className={classes.descriptionText}>
        Selecione um ou mais talhões para fazer a análise comparativa. Apenas
        talhões com mais de dois diagnósticos podem ser analisados.
      </Typography>
    </Box>
  )
}
